import React from 'react'
import { LoungeListScreen } from '@/screens/lounges/LoungeListScreen'

export default function LoungesRoute() {
  return <LoungeListScreen />
}
